export default __webpack_public_path__ + "static/media/search.0b74c1d0.svg";